import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/enroll-popup-close-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-643d5f0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "enroll-popup" }
const _hoisted_2 = { class: "enroll-box" }
const _hoisted_3 = { class: "hint-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_btn = _resolveComponent("custom-btn")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "coupon-popup-wrapper",
    onTouchmove: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: "mask",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePopup(false)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.popupType === 1 ? _ctx.driveEnrollHint : _ctx.couponEnrollHint), 1)
        ]),
        _createElementVNode("div", {
          class: "submit-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmButtonClick && _ctx.confirmButtonClick(...args)))
        }, [
          _createVNode(_component_custom_btn, {
            size: 'big',
            bgColor: _ctx.activityInfo.subjectRgb
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.popupType === 1 && _ctx.browserEnv === 3 ? '去下载app' : '我知道了'), 1)
            ]),
            _: 1
          }, 8, ["bgColor"])
        ])
      ]),
      _createElementVNode("div", {
        class: "enroll-close-btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.togglePopup(false)))
      }, _hoisted_5)
    ])
  ], 544)), [
    [_vShow, _ctx.isShowPopup]
  ])
}